
export const DEFAULT_ANIMATION_SPEED = 10;
export const DEFAULT_ALGO_VALUE = 'bfs';
export const DEFAULT_IS_ANIMATION_ENABLED = true;

export const PATH_ANIMATION_SPEED_SECONDS = 0.3;